export * from './Switch';
export { default } from './Switch';
//# sourceMappingURL=index.js.map